import { Button, ButtonProps } from '@mui/material';
import { CloudDownload } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

type SttButtonDownloadProps = {
    caption?: string;
    onClick: () => void;
} & ButtonProps;

/**
 * Download button
 */
export function SttButtonDownload({
    caption,
    onClick,
    ...rest
}: SttButtonDownloadProps) {
    const { t } = useTranslation();

    return (
        <Button
            {...rest}
            variant="contained"
            color="inherit"
            startIcon={<CloudDownload />}
            onClick={onClick}
        >
            {caption || t('Download')}
        </Button>
    );
}
